import React, { useEffect, useState } from "react";

import { useParams } from "react-router-dom";

import informationGuidesApi from "apis/informationGuide";
import {
  PageLoader,
  SubHeader,
  Tab,
  Typography,
} from "components/Common/clearsense-ui/components";

import { INFORMATION_GUIDE_TABS } from "./constants";
import Content from "./Content";
import DetailedDescription from "./DetailedDescription";
import Examples from "./Examples";
import JSONDescription from "./JSONDescription";
import { convertToProperCase } from "./utils";

const Tabs = () => {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState({ tab: "content" });

  const { resource } = useParams();

  const handleFileFetching = async () => {
    setIsLoading(true);
    try {
      const response = await informationGuidesApi.fetch(resource);
      setData({
        description: response?.data.information_guides?.description,
        examples: response?.data?.examples,
      });
    } catch (error) {
      logger.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    handleFileFetching();
    setActiveTab({ tab: "content" });
  }, [resource]);

  if (isLoading) return <PageLoader />;

  return (
    <div className="cs-ui-container cs-ui-container__table">
      <SubHeader
        className="mt-8 mb-2"
        breadcrumbs={[
          { label: "Reference Data", link: "#" },
          {
            label: "FHIR Information Guide",
            link: "/management/reference-data/fhir-information-guide",
          },
          {
            label: "US Core",
            link: "/management/reference-data/fhir-information-guide",
          },
          {
            label: convertToProperCase(
              data?.description?.snapshot?.element?.[0]?.id
            ),
            link: "#",
          },
        ]}
      />
      <div className="space-y-4">
        <Typography style="h3" type="semibold" className="mb-3">
          Resource Profile:{" "}
          {data?.description?.title?.slice(0, 2) +
            convertToProperCase(data?.description?.title?.slice(2))}
        </Typography>
        <Tab style="secondary">
          {INFORMATION_GUIDE_TABS.map((tab, index) => {
            if (tab["label"] === "Examples" && data.examples.length === 0) {
              return null;
            }

            return (
              <Tab.Item
                key={index}
                active={activeTab.tab === tab["tabName"]}
                onClick={() => setActiveTab({ tab: tab["tabName"] })}
              >
                {tab["label"]}
              </Tab.Item>
            );
          })}
        </Tab>
        {activeTab.tab === "content" && (
          <Content
            data={data}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
        )}
        {activeTab.tab === "description" && (
          <DetailedDescription
            description={data?.description}
            activeTab={activeTab}
          />
        )}
        {activeTab.tab === "json" && (
          <JSONDescription
            description={data?.description}
            activeTab={activeTab}
          />
        )}
        {activeTab.tab === "examples" && (
          <Examples examples={data.examples} activeTab={activeTab} />
        )}
      </div>
    </div>
  );
};
export default Tabs;
